import React from 'react';
export function Footer() {
  return <footer className="w-full bg-[#030308] py-16 px-4 border-t border-white/5" data-id="element-100">
      <div className="max-w-4xl mx-auto text-center" data-id="element-101">
        <div className="text-white text-3xl font-black tracking-widest mb-6 flex items-center justify-center gap-3 drop-shadow-[0_0_15px_rgba(255,255,255,0.2)]" data-id="element-102">
          <span className="text-4xl" data-id="element-103">🧘</span> Pilates Elite™
        </div>

        <p className="text-white/80 text-lg leading-relaxed mb-3 max-w-xl mx-auto font-medium" data-id="element-104">
          Il sistema N.1 per istruttrici di Pilates professioniste.
        </p>
        <p className="text-white/50 text-sm italic mb-10" data-id="element-105">
          Perché insegnare Pilates non dovrebbe costarti ogni notte della
          settimana.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-sm text-white/70 mb-10" data-id="element-106">
          <span className="hover:text-white transition-colors cursor-pointer flex items-center gap-2" data-id="element-107">
            <span data-id="element-108">📧</span> soporte.edulabs@gmail.com
          </span>
        </div>

        <div className="h-px bg-gradient-to-r from-transparent via-white/10 to-transparent mb-8 w-full max-w-lg mx-auto" data-id="element-109" />

        <p className="text-white/30 text-xs tracking-wider" data-id="element-110">
          © Pilates Elite™ 2026 — Tutti i diritti riservati.
        </p>
      </div>
    </footer>;
}